
export function encodeParam(param) {
    return encodeURIComponent(param).replace(/\(/g, "%28").replace(/\)/g, "%29");
}
